module.exports = __webpack_public_path__ + "static/media/unknown.91059716.gif";